import { z } from "zod";

const positiveIntSchema = z.number().int().positive();

export const paymentMethodItemSchema = z.object({
  id: z.coerce.number().int().positive(),
  descrizione: z.string(),
  urlLogo: z.string().nullable().optional(),
});

export const paymentMethodListResponseSchema = z.array(paymentMethodItemSchema);

export const paymentMethodSaveRequestSchema = z.object({
  id: positiveIntSchema.optional().nullable(),
  descrizione: z.string().trim().min(1).max(255),
  urlLogo: z.string().trim().max(255).optional().nullable(),
});

export const paymentMethodDeleteRequestSchema = z.object({
  id: positiveIntSchema,
});

export function validatePaymentMethodSaveRequest(data) {
  return paymentMethodSaveRequestSchema.parse(data);
}

export function validatePaymentMethodDeleteRequest(data) {
  return paymentMethodDeleteRequestSchema.parse(data);
}

export function parsePaymentMethodListResponse(data) {
  return paymentMethodListResponseSchema.parse(data ?? []);
}
